<template>
  <div>
    <v-layout wrap justify-start mx-8>
      <v-flex md8 offset-2 text-center>
        <BlogCategorySlider @stepper="winStepper" />
      </v-flex>

      <v-flex xs12 sm8 md8 lg8 xl8 offset-sm2 offset-md2 offset-lg2 offset-xl2 offset-xs0 my-4  v-for="(item, i) in user" :key="i">
        <!-- <OwlCarousel :nav="false" :dots="true" :responsive="owlResponsive"> -->
        <a :href="item.link">
          <v-card tile outlined  >
            <v-layout
              @click="
                $router.push({
                  path: 'blogDetails',
                  query: {
                    id: item._id,
                  },
                })
              "
              wrap
              justify-center
            >
              <v-flex xs12 sm6 align-self-center pl-3>
                <v-img :src="mediaURL + item.image" height="250" cover>
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#FF2323"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <v-layout wrap justify-start pa-4>
                  <v-flex xs12>
                    <span
                      style="
                        font-family: poppinsregular;
                        font-size: 14px;
                        color: #6b6b6b;
                      "
                    >
                      {{ formatDate(item.blogdate).slice(0,11) }}
                    </span>
                  </v-flex>
                  <v-flex pt-4 xs12 text-left style="line-height: 16px">
                    <span
                      class="text-uppercase"
                      style="
                        font-family: poppinssemibold;
                        font-size: 20px;
                        color: #000000;
                      "
                    >
                      {{ item.title }}
                    </span>
                  </v-flex>
                  <v-flex pt-4 xs12 text-left >
                    <span
                    v-html="(item.text).slice(0,300 )+' ..'"
                      style="
                        font-family: poppinsregular;
                        font-size: 16px;
                        color: #000000;
                      "
                    >
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </a>
        
        <!-- </OwlCarousel> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import BlogCategorySlider from "./blogCategorySlider";
export default {
  components: { BlogCategorySlider },
  data() {
    return {
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 2, nav: false },
        960: { items: 2, nav: false },
        1264: { items: 3, nav: false },
      },
      user: [],
      category: null,
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    category() {
      this.getData();
    },
  },
  methods: {
    winStepper(windowData) {
      if (windowData.type == "blogCategory") {
        if (windowData.pageResponse) {
          this.category = windowData.pageResponse._id;
        }
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/home/newblog/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          category: this.category,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>